// Bloc du tableau de bord : logements, vacance et échéances de diagnostics.
import { Link } from "react-router";
import { date } from "@core/format";
import { useGet } from "@core/hooks";
import { Card, ErrorBox, Loading, Stat } from "@core/ui";
import { DiagChip, type DiagStatus } from "./shared";

type Summary = {
  properties: number;
  vacant: number;
  occupied: number;
  diagnostics_due: { property_id: string; property_label: string; kind: string; kind_label: string; status: DiagStatus; valid_until: string | null }[];
  diagnostics_missing: number;
  pending_verifications: number;
  quota: { used: number; limit: number | null };
};

export function PatrimoineDashboard({ orgId }: { orgId: string }) {
  const q = useGet<Summary>(`/api/v1/orgs/${orgId}/patrimoine/summary`);
  const base = `/espace/${orgId}`;
  return (
    <Card title="Logements" actions={<Link to={`${base}/logements`}>Voir les logements</Link>}>
      {q.isLoading ? <Loading /> : null}
      <ErrorBox error={q.error} />
      {q.data ? (
        <>
          <div className="stats">
            <Stat label="Logements gérés" value={q.data.properties} hint={q.data.quota.limit !== null ? `sur ${q.data.quota.limit} dans votre offre` : undefined} />
            <Stat label="Vacants" value={q.data.vacant} />
            <Stat label="Échéances de diagnostics" value={q.data.diagnostics_due.length} hint="échus ou à moins de 90 jours" />
          </div>
          {q.data.diagnostics_due.length ? (
            <ul className="pat-due">
              {q.data.diagnostics_due.slice(0, 5).map((d) => (
                <li key={`${d.property_id}-${d.kind}`}>
                  <span>
                    <Link to={`${base}/logements/${d.property_id}?onglet=diagnostics`}>{d.property_label}</Link>
                    <span className="pat-sub">
                      {d.kind_label}
                      {d.valid_until ? ` · jusqu’au ${date(d.valid_until)}` : ""}
                    </span>
                  </span>
                  <DiagChip status={d.status} />
                </li>
              ))}
            </ul>
          ) : (
            <p className="small muted">Aucune échéance de diagnostic dans les 90 prochains jours.</p>
          )}
          {q.data.diagnostics_missing ? <p className="small">{q.data.diagnostics_missing} diagnostic{q.data.diagnostics_missing > 1 ? "s" : ""} exigé{q.data.diagnostics_missing > 1 ? "s" : ""} sans pièce enregistrée.</p> : null}
          {q.data.pending_verifications ? <p className="small">Vérification du bailleur en attente d’examen pour {q.data.pending_verifications} logement{q.data.pending_verifications > 1 ? "s" : ""}.</p> : null}
        </>
      ) : null}
    </Card>
  );
}
